import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import WarningIcon from '@swf/core/assets/icons/warning.svg';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';

import { useWidgetTheme } from '../../../hooks';
import BaseHeader from '../BaseHeader/BaseHeader';

import {
  TXTCLI_Maximum_tables_reached,
  TXTCLI_OK,
  TXTCLI_You_can_only_play_N0_tables_at_ELL
} from './ActiveTableLimit.messages.json';
import styles from './ActiveTableLimit.scss';

const ActiveTableLimit: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { maxActiveGames } = useSearchParams<{ maxActiveGames: number }>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const lightModeFFEnabled = useFeature(FeatureFlag.PKRHomeGamesLightMode);
  const { className } = useWidgetTheme(lightModeFFEnabled);

  useEffect(() => {
    setStyle({
      overlayClassName: classNames(className, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <div>
      <BaseHeader
        headerClassName={styles.header}
        title={<Translation {...TXTCLI_Maximum_tables_reached} />}
      />
      <div className={styles.body}>
        <WarningIcon width="60" height="60" className={styles.warningIcon} />
        <Translation
          tagName="p"
          {...TXTCLI_You_can_only_play_N0_tables_at_ELL}
          values={{ 0: maxActiveGames }}
        />
        <StarsButton
          className={styles.button}
          onClick={() => modal.close()}
          translation={TXTCLI_OK}
        />
      </div>
    </div>
  );
};

export default ActiveTableLimit;
